import {
  TasksValueObjectsTaskCategoryEnum,
  TasksValueObjectsTaskStatusEnum,
} from 'generated/resources/datatable.graphql'

import { track } from 'modules/core/lib/Tracking/tracker'

export const events = {
  goToInbox: 'Go to Inbox',
  goToDiscardInboxTask: 'Go to Discard Inbox Task',
  goToTaskDetail: 'Go to Task Detail',
  closeTask: 'Close Task',
  clickInboxAction: 'Click Inbox Action',
  clickInboxFilters: 'Click Inbox Filters',
  clickInboxPreset: 'Click Inbox Preset',
  clickInboxSorting: 'Click Inbox Sorting',
  discardInboxTask: 'Discard Inbox Task',
} as const

type EventParams = {
  [events.goToInbox]: {
    type: 'todo' | 'completed'
    count: number
  }
  [events.goToDiscardInboxTask]: {
    category?: TasksValueObjectsTaskCategoryEnum
  }
  [events.goToTaskDetail]: {
    category?: TasksValueObjectsTaskCategoryEnum
    status: TasksValueObjectsTaskStatusEnum
  }
  [events.closeTask]: {
    category?: TasksValueObjectsTaskCategoryEnum
  }
  [events.clickInboxAction]: {
    type: string
  }
  [events.clickInboxFilters]: {
    categories: TasksValueObjectsTaskCategoryEnum[]
  }
  [events.clickInboxPreset]: {
    category: TasksValueObjectsTaskCategoryEnum
  }
  [events.clickInboxSorting]: {
    type: 'created_at' | 'due_date'
  }
  [events.discardInboxTask]: {
    category?: TasksValueObjectsTaskCategoryEnum
  }
}

export const trackGoToInbox = (params: EventParams[typeof events.goToInbox]) => {
  track(events.goToInbox, params)
}

export const trackGoToDiscardInboxTask = (
  params: EventParams[typeof events.goToDiscardInboxTask]
) => {
  track(events.goToDiscardInboxTask, params)
}

export const trackGoToTaskDetail = (params: EventParams[typeof events.goToTaskDetail]) => {
  track(events.goToTaskDetail, params)
}

export const trackCloseTask = (params: EventParams[typeof events.closeTask]) => {
  track(events.closeTask, params)
}

export const trackClickInboxAction = (params: EventParams[typeof events.clickInboxAction]) => {
  track(events.clickInboxAction, params)
}

export const trackClickInboxFilters = (params: EventParams[typeof events.clickInboxFilters]) => {
  track(events.clickInboxFilters, params)
}

export const trackClickInboxPreset = (params: EventParams[typeof events.clickInboxPreset]) => {
  track(events.clickInboxPreset, params)
}

export const trackClickInboxSorting = (params: EventParams[typeof events.clickInboxSorting]) => {
  track(events.clickInboxSorting, params)
}

export const trackDiscardInboxTask = (params: EventParams[typeof events.discardInboxTask]) => {
  track(events.discardInboxTask, params)
}
